<template>
  <div class="orderpayContainer">
    <div class="orderPay w">
      <div class="title">订单支付</div>
      <div class="orderInfo">
        <ul>
          <li>
            <div class="name">采购订单编号:</div>
            <div class="conent">{{ info.Number }}</div>
          </li>
          <li>
            <div class="name">发票状态:</div>
            <div class="conent">{{ info.fpstate }}</div>
          </li>
          <li>
            <div class="name">收货人信息:</div>
            <div class="conent">{{ info.shperson }} {{ info.shphone }}</div>
          </li>
          <li>
            <div class="name">收货区域:</div>
            <div class="conent">{{ info.shadress }}</div>
          </li>
          <li>
            <div class="name">详细地址:</div>
            <div class="conent">{{ info.sharea }}</div>
          </li>
          <li>
            <div class="name">备注:</div>
            <div class="conent">{{ info.summary ? info.summary : "无" }}</div>
          </li>
        </ul>
        <div class="infobox clearfix">
          <div class="pirce">
            实付：
            <b>{{
              parseFloat(
                parseFloat(info.Total) + parseFloat(info.kdf) + taxes
              ).toFixed(2)
            }}</b>
            元
          </div>
        </div>
      </div>
      <div class="pay">
        <div class="name">支付方式:</div>
        <div class="radioContainer" v-if="info.fpstate !== '增值税专用发票'">
          <el-radio-group v-model="radio" @change="radioChange">
            <el-radio label="0">
              扫描聚合二维码付款  名称:派普建材店   付款前请备注:商户名称/名字
              <!-- <img src="./images/wx.png" alt="" /> -->
            </el-radio>
            <!-- <el-radio label="1"><img src="./images/zfb.png" alt="" /></el-radio> -->
            <!-- <el-radio label="2">公户账号</el-radio> -->
            <!-- <el-radio label="3">私户账号</el-radio> -->
          </el-radio-group>
        </div>
        <div class="radioContainer" v-else>
          <el-radio-group v-model="radio" @change="radioChange">
            <el-radio label="2" style="padding: 12px">公户账号</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="z">(注：选择开增值税票后只显示银行公户账户)</div>

      <div class="radioTabBox">
        <div class="code">
          <img src="./images/juhema.jpg" alt="" v-if="flag == '1'" />
          <img src="./images/juhema.jpg" alt="" v-else-if="flag == '0'" />
          <img src="./images/sihu.png" alt="" v-else-if="flag == '3'" />
          <img src="./images/gonghu.png" alt="" v-else-if="flag == '2'" />
        </div>
        <div class="radioTitle">
          <p>
            付款后请耐心等待10-20分钟，后台客服人员审核订单后，订单状态会变更为已付款。
          </p>
          <p>暂不付款的订单可到订单中心查找。</p>
        </div>
        <div class="btns">
          <div class="item">
            <div class="name">支付成功请点击</div>
            <div class="btn" @click="paymentChange">已完成付款</div>
          </div>
          <div class="item i-border">
            <div class="name">遇到问题返回产品中心请点击</div>
            <div class="btn i-ba" @click="$router.push('/product')">
              暂不付款
            </div>
          </div>
          <div class="item">
            <div class="name">如需打印订单请点击</div>
            <div class="btn i-ba" @click="orderPageChange(info.Number)">
              <i class=""></i>
              打印订单
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sunmitOrderRouter } from "@/router";
import { getorderbill, chenkpaybill } from "@/api";
export default {
  data() {
    return {
      radio: "1",
      info: {},
      taxes: 0,
      flag: "1",
    };
  },
  methods: {
    radioChange(val) {
      this.flag = val;
    },
    async paymentChange() {
      let paytype = "";
      if (this.radio == "0") {
        paytype = "微信";
      } else if (this.radio == "1") {
        paytype = "支付宝";
      } else if (this.radio == "2") {
        paytype = "公户账号";
      } else if (this.radio == "3") {
        paytype = "私户账号";
      }
      let billno = this.$route.query.Number;
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await chenkpaybill({
        usercode,
        token,
        billno,
        flag: "0",
        paytype,
      });
      const result = JSON.parse(res)[0];
      if (result.code !== 200) {
        this.$notify.error({
          title: "错误",
          message: result.message,
          duration: 2000,
        });
      } else {
        this.$notify({
          title: "成功",
          message: result.message,
          type: "success",
          duration: 2000,
        });
        this.$store.commit("changeIndex", 1);
        this.$router.addRoutes(sunmitOrderRouter);
        this.$router.push({
          path: "/sunmitorder",
          query: {
            Number: billno,
          },
        });
      }
    },
    async getorderbillInfo(billno) {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await getorderbill({
        usercode,
        token,
        billno,
      });
      this.info = JSON.parse(res)[0];
      if (this.info.taxtype !== "无需开票") {
        this.taxes = this.info.Total * 0.08;
      } else {
        this.taxes = 0;
      }
      // console.log(this.info);
      if (this.info.fpstate == "增值税专用发票") {
        this.radio = "2";
        this.flag = "2";
      } else {
        this.radio = "0";
        this.flag = "0";
      }
    },
    orderPageChange(Number) {
      this.$router.push({
        path: "/inventory",
        query: {
          type: 0,
          Number,
        },
      });
    },
  },
  mounted() {
    this.getorderbillInfo(this.$route.query.Number);
  },
};
</script>
<style lang='less' scoped>
.orderpayContainer {
  .orderPay {
    .radioTabBox {
      margin-top: 10px;
      .code {
        text-align: center;
      }
      .radioTitle {
        font-size: 0;
        p {
          text-align: center;
          line-height: 25px;
          font-size: 14px;
          color: #343434;
        }
      }
      .btns {
        padding: 15px 50px;
        display: flex;
        justify-content: center;
        .i-border {
          border-left: 2px solid #d2d2d2;
          border-right: 2px solid #d2d2d2;
        }
        .item {
          padding: 0 30px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .i-ba {
            background: #cccccc;
            color: #343434;
          }
        }
        .name {
          margin-bottom: 5px;
          color: #333333;
        }
        .btn {
          cursor: pointer;
          font-size: 14px;
          width: 110px;
          height: 35px;
          color: #fff;
          text-align: center;
          line-height: 35px;
          background: #e4040c;
        }
      }
    }
    .z {
      padding-left: 95px;
      margin-top: 5px;
      color: #e30409;
    }
    .pay {
      padding-top: 20px;
      .radioContainer {
        border: 1px solid #f5f5f5;
        padding: 5px 15px;
        img {
          width: 110px;
          vertical-align: middle;
        }
      }
      .name {
        line-height: 50px;
        margin-right: 30px;
        font-size: 14px;
      }
      display: flex;
    }
    .orderInfo {
      .infobox {
        height: 20px;
        line-height: 20px;
        .site {
          float: left;
          margin-left: 100px;
        }
        .pirce {
          float: right;
          b {
            font-size: 20px;
            font-weight: 600;
            color: #eb4f57;
          }
        }
      }
      padding: 10px 20px;
      background: #f3f4f6;
      ul li {
        display: flex;
        height: 30px;
        line-height: 30px;
        .name {
          width: 100px;
          color: #676767;
        }
        .conent {
          color: #323433;
        }
      }
    }
    .title {
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 16px;
      color: #333333;
    }
  }
}
</style>